// // src/components/ForgotPassword.jsx
// import React, { useState } from "react";

// export default function ForgotPassword() {
//   const [email, setEmail] = useState("");
//   const [message, setMessage] = useState("");

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Placeholder: Call API to reset password
//     setMessage(`Password reset link sent to ${email}`);
//   };

//   return (
//     <div className="flex justify-center items-center min-h-screen bg-gray-100">
//       <form
//         className="bg-white p-6 rounded shadow-md w-96"
//         onSubmit={handleSubmit}
//       >
//         <h2 className="text-2xl font-bold mb-4 text-center">Forgot Password</h2>
//         {message && <p className="text-green-500 mb-2">{message}</p>}
//         <label className="block mb-2">Email</label>
//         <input
//           type="email"
//           required
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           className="w-full border p-2 rounded mb-4"
//         />
//         <button
//           type="submit"
//           className="w-full bg-blue-600 text-white p-2 rounded"
//         >
//           Send Reset Link
//         </button>
//       </form>
//     </div>
//   );
// }
import React, { useState } from "react";
import api from "../api/axiosInstance";

export default function ForgotPassword() {
  const [username, setUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    // 🔍 Basic validation
    if (newPassword.length < 4) {
      setError("❌ Password must be at least 4 characters long.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("❌ New Password and Re-enter Password do not match.");
      return;
    }

    setLoading(true);

    try {
      // ✅ Use axios instance here
      const response = await api.post("/Auth/update-password", {
        username,
        newPassword,
      });

      setMessage(`✅ ${response.data.message}`);
      setUsername("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      console.error("Password update error:", err);
      console.log("No Error");
      setError(
        `❌ ${
          err.response?.data?.message ||
          err.message ||
          "Password update failed"
        }`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-yellow-100">
      <form
        className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md border border-yellow-200"
        onSubmit={handleSubmit}
      >
        <h2 className="text-2xl font-extrabold mb-4 text-center text-yellow-700">
          Reset Password
        </h2>

        {message && <p className="text-green-600 mb-3 text-center">{message}</p>}
        {error && <p className="text-red-600 mb-3 text-center">{error}</p>}

        <div className="mb-4">
          <label className="block mb-1 text-yellow-800 font-medium">
            Username
          </label>
          <input
            type="text"
            required
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full border border-yellow-100 bg-yellow-100 px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500"
            placeholder="Enter your username"
          />
        </div>

        <div className="mb-4">
          <label className="block mb-1 text-yellow-800 font-medium">
            New Password
          </label>
          <input
            type="password"
            required
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="w-full border border-yellow-100 bg-yellow-100 px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500"
            placeholder="Enter new password"
          />
        </div>

        <div className="mb-6">
          <label className="block mb-1 text-yellow-800 font-medium">
            Re-enter Password
          </label>
          <input
            type="password"
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="w-full border border-yellow-100 bg-yellow-100 px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500"
            placeholder="Re-enter new password"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-gradient-to-r from-yellow-500 to-yellow-600 text-white font-semibold py-2 rounded-lg hover:from-yellow-600 hover:to-yellow-700 transition-all shadow-md disabled:opacity-50"
        >
          {loading ? "Updating..." : "Update Password"}
        </button>

        <p className="text-center text-sm text-gray-600 mt-4">
          Go back to{" "}
          <a href="/" className="text-yellow-700 font-medium hover:underline">
            Login
          </a>
        </p>
      </form>
    </div>
  );
}
